import React from 'react';
import RaceList from './RaceList';

const Race = () => {
  return <RaceList />;
};

export default Race;
